import { gql } from '@apollo/client';

export const ASSISTANT_ENABLED = gql`
  query AssistantEnabled {
    assistantEnabled
  }
`;

export const ASSISTANT_CHAT = gql`
  mutation AssistantChat(
    $conversationId: String
    $message: String!
    $action: String
    $language: String
  ) {
    assistantChat(
      input: {
        conversationId: $conversationId
        message: $message
        action: $action
        language: $language
      }
    ) {
      conversationId
      reply
      changed
      options {
        label
        action
        admin
      }
      qr {
        value
        caption
      }
      language
    }
  }
`;
